<template>
  <div class="animated revealUp">
    <div class="master-container">
      <div class="master-box" v-for="(Nav, index) in ModuleArray" :key="index">
        <router-link :to="Nav.url">
          <div>
            <h4>{{ $tc(Nav.name, 2) }}</h4>
            <p>{{ $t(Nav.description) }}</p>
          </div>
          <div>
            <img
              src="@/assets/img/icons/arrow-right.svg"
              width="20"
              height="20"
              alt
            />
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Nav from "@/Nav";
import { mapGetters, mapActions } from "vuex";
import { checkAccessController, checkParentId } from "@/helper/AccessControl";
import UserService from "@/services/UserService";
export default {
  data() {
    return {
      SideNav: Nav.items,
      isSidebarShow: false,
      checkUpdate: false,
      modules: [],
      count: 0,
      ModuleArray: []
    };
  },
  computed: {
    getGLobalOption() {
      return this.secureStore.get("MYCINEMASTATUS") || "N";
    },
    isGoGoCinema() {
      let isGogoCinema = this.$store.getters.isGogoCinema == "Y" ? true : false;
      return isGogoCinema;
    },
    ModuleBoxes() {}
  },
  beforeMount() {
    this.getModuleList();
  },
  methods: {
    checkArrayModuleNew(x) {
      if (this.isGoGoCinema && x.hasOwnProperty("GogoName")) {
        x["name"] = x.GogoName;
      }
      if (x.hasOwnProperty("children")) {
        x.children.map(y => {
          if (this.isGoGoCinema && y.hasOwnProperty("GogoName")) {
            y["name"] = y.GogoName;
          }
          if (y.hasOwnProperty("children")) {
            this.checkArrayModuleNew(y);
          } else {
            let checkModule = this.modules.filter(z => {
              return z.module_id == y.module_id;
            });
            if (
              checkModule.length > 0 &&
              checkModule[0].module_is_active == "Y"
            ) {
              this.ModuleArray.push(y);
            }
          }
        });
      } else {
        let checkModule = this.modules.filter(z => {
          return z.module_id == x.module_id;
        });
        if (checkModule.length > 0 && checkModule[0].module_is_active == "Y") {
          this.ModuleArray.push(x);
        }
      }
    },
    getModuleList: function() {
      let loader = this.$loading.show();
      UserService.ModulesList()
        .then(response => {
          const { data } = response;
          if (data.status) {
            this.modules = data.Records;
            this.SideNav[1].children.map(x => {
              if (x.name != "Home") {
                this.checkArrayModuleNew(x);
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(err => {
          console.log("Error:", err);
        })
        .finally(x => setTimeout(() => loader.hide(), 2500));
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/UserManagement/UsersManagementHome.vue